import { ArrowUpRight } from "lucide-react";
import { RESTAURANTS } from "@/data/restaurants";
import { trackClick } from "@/lib/tracking";

export default function Footer() {
  return (
    <footer className="border-t border-white/10 bg-ink" data-testid="footer">
      <div className="mx-auto max-w-7xl px-5 py-16 md:px-10">
        <div className="flex flex-col justify-between gap-12 md:flex-row">
          <div>
            <div className="flex items-center gap-3">
              <img
                src="/logos/all4you.png"
                alt="All For You"
                className="h-11 w-auto"
                style={{ filter: "invert(1)" }}
              />
            </div>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-zinc-500">
              Ma Biche sur le Toit, Compagnie Française, Café Chouchou, Coup de
              Bambou et Compagnie Française Busca : les maisons toulousaines du
              groupe All For You, ouvertes chaque soir en dehors de la zone de
              couvre-feu.
            </p>
          </div>
          <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 sm:gap-x-16">
            {RESTAURANTS.map((r) => (
              <div key={r.id} data-testid={`footer-${r.id}`}>
                {r.logo ? (
                  <img
                    src={r.logo}
                    alt={r.name}
                    className={`w-auto ${r.logoClassSm || "h-7"}`}
                  />
                ) : (
                  <p className="font-display text-xl text-bone">{r.name}</p>
                )}
                <p className="mt-1 text-xs leading-relaxed text-zinc-500">
                  {r.address}
                </p>
                <a
                  href={r.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`footer-reserve-${r.id}`}
                  onClick={() => trackClick(r.id)}
                  className="mt-2 inline-flex items-center gap-1 text-xs uppercase tracking-[0.2em] text-gold transition-colors hover:text-champagne"
                >
                  {r.ctaLabel || "Réserver"} <ArrowUpRight size={13} />
                </a>
              </div>
            ))}
          </div>
        </div>
        <div className="mt-14 flex flex-col justify-between gap-3 border-t border-white/10 pt-6 text-xs text-zinc-600 sm:flex-row">
          <p>© {new Date().getFullYear()} Groupe All For You · Toulouse</p>
          <p>L'abus d'alcool est dangereux pour la santé.</p>
          <p>Horaires donnés à titre indicatif.</p>
        </div>
      </div>
    </footer>
  );
}
